module.exports = __webpack_public_path__ + "static/media/ac4b0f01-a5b1-4cb1-ad2a-51fa40085356.918037fd.jpeg";